/**
 * Filtr formatujący adres obiektu najpierw ulica
 *
 * @export
 * @param {*} item
 * @returns
 */
export function address(item) {
    if (!item || (!item.city && !item.street)) {
        return 'Brak';
    }
    const cityString = [item.postalCode, item.city].filter(Boolean).join(' ');
    const commaValues = [street(item), cityString];
    return commaValues.filter(Boolean).join(', ');
}
/**
 * Filtr formatujący adres obiektu najpierw miasto
 *
 * @export
 * @param {*} item
 * @returns
 */
export function addressCityFirst(item) {
    if (!item.city && !item.street) {
        return 'Brak';
    }
    const commaValues = [city(item), item.postCode];
    return commaValues.filter(Boolean).join(', ');
}
/**
 * Filtr formatujący tylko ulicę z adresu
 *
 * @export
 * @param {*} item
 * @returns {string}
 */
export function street(item) {
    let addressString = '';
    if (item.street) {
        addressString += item.street;
    }
    else if (item.city) {
        addressString += item.city;
    }
    return homeNumber(item, addressString);
}
/**
 * Filtr formatujący tylko miasto z adresu
 *
 * @export
 * @param {*} item
 * @returns {string}
 */
export function city(item) {
    let addressString = '';
    if (item.city) {
        addressString += item.city;
    }
    if (item.street) {
        addressString += ', ' + item.street;
    }
    return homeNumber(item, addressString);
}
/**
 * Filtr zwracający sformatowany numer domu / lokalu
 *
 * @export
 * @param {*} item
 * @param {*} addressString
 * @return {*}  {string}
 */
export function homeNumber(item, addressString) {
    if (addressString && item.homeNumber) {
        addressString += ' ';
        addressString += item.homeNumber + (item.localNumber ? '/' + item.localNumber : '');
    }
    return addressString;
}
//# sourceMappingURL=address.js.map